import { Box } from '@tonic-one/react';
import backgroundSvg from '../../welcome-backend.svg';

const GradientBackground = () => {
  return (
    <Box
      position="absolute"
      width="100%"
      minHeight="794px"
      top="0"
      left="0"
      overflow="hidden"
      pointerEvents="none"
      zIndex={0}
    >
      <img
        src={backgroundSvg}
        alt=""
        style={{
          width: '100%',
          minWidth: '1616px',
          height: 'auto',
          display: 'block',
          margin: '0 auto',
        }}
      />
    </Box>
  );
};

export default GradientBackground;
